module.exports = __webpack_public_path__ + "static/media/med-cert-logo.3044bfa5.png";